import React, { Component } from 'react';
import moment from 'moment';

import TimeoutSignsSettingsForm from './TimeoutSignsSettingsForm';

import { defaultSorter, dateSorter } from './Helpers';
import TimeoutSignsModel from './TimeoutSignsModel';
import UserModel from './UserModel';

import { Table, Badge, Divider, Row, Col, Card, Popconfirm, Typography, message, Tag, Tooltip } from 'antd';

class TimeoutSignsTable extends Component {

  state = {
    children: [],
    filteredInfo: {},
    sortedInfo: {},
    timeoutSignsSettingsFormData: null
  }

  handleChange = (pagination, filters, sorter) => {
    this.setState({
      filteredInfo: filters,
      sortedInfo: sorter,
    });
  }

  expandedRowRender(record) {
    return (
      <div>
        <Row style={{ marginBottom: 20 }}>
          <Col span={12}>
            <Card title="Popis">
              {record.description}
            </Card>
          </Col>
          <Col span={3}>
            <Card title="Z. šířka">
              {record.coords.coordinates[1]}
            </Card>
          </Col>
          <Col span={3}>
            <Card title="Z. výška">
              {record.coords.coordinates[0]}
            </Card>
          </Col>
          <Col span={6}>
            <Card title="Poslední komunikace do značky">
              {moment(record.lastCommunication).format('L LTS')}
            </Card>
          </Col>
          <Col span={18}>
            <Card title="Událost">
              {record.eventListener}
            </Card>
          </Col>
          <Col span={6}>
            <Card title="Vynucení neaktivity">
              {
                record.forceInactive
                  ? <Badge
                    status="success"
                    text={"ZAPNUTO"}
                    title="Zapnuto" />
                  : <Badge
                    status="error"
                    text={"VYPNUTO"}
                    title="Vypnuto" />
              }
            </Card>
          </Col>
          <Col span={24}>
            <Card title="Aktivní hodiny">
              <ul style={{ listStyleType: 'none', paddingInline: '1rem', lineHeight: '1.5rem' }}>
                {record.activeHours ? Object.keys(record.activeHours).map((key, index) => {
                  const days = {
                    'Monday': 'Pondělí',
                    'Tuesday': 'Úterý',
                    'Wednesday': 'Středa',
                    'Thursday': 'Čtvrtek',
                    'Friday': 'Pátek',
                    'Saturday': 'Sobota',
                    'Sunday': 'Neděle'
                  };

                  const hours = record.activeHours[key];

                  if (hours.length > 0) {
                    return (
                      <li key={key}>
                        <b>{days[key]}</b>:&nbsp;
                        {hours.map((hour, index) => {
                          const from = moment(hour.split('-')[0], 'HH:mm');
                          const to = moment(hour.split('-')[1], 'HH:mm');
                          return (
                            <span key={index}>
                              {from.format('HH:mm')} - {to.format('HH:mm')}
                              {index !== hours.length - 1 ? ', ' : ''}
                            </span>
                          )
                        })}
                      </li>
                    )
                  } else {
                    return (
                      <li key={key}>
                        <b>{days[key]}</b>:&nbsp;
                        <span>00:00 - 23:59</span>
                      </li>
                    )
                  }
                }) : null}
              </ul>
            </Card>
          </Col>

        </Row>
      </div >
    );
  }

  render() {

    let { sortedInfo, filteredInfo } = this.state;

    const columns = [{
      title: 'Lokalita',
      dataIndex: 'parkingLocationName',
      key: 'parkingLocationName',
      width: 250,
      sorter: (a, b) => defaultSorter(a.parkingLocationName, b.parkingLocationName),
    }, {
      title: 'Místo',
      dataIndex: 'eventListener',
      key: 'eventListener',
      width: 40,
      render: (text, record) => {
        const parts = record.eventListener.split('/');
        return parts[4]
      }
    }, {
      title: 'Časovač',
      dataIndex: 'timerName',
      key: 'timerName',
      width: 90,
      sorter: (a, b) => defaultSorter(a.timerName, b.timerName),
    }, {
      title: 'Poslední změna stavu',
      dataIndex: 'lastStateChanged',
      key: 'lastStateChanged',
      width: 180,
      sorter: (a, b) => dateSorter(a.lastStateChanged, b.lastStateChanged),
      render: (text, record) => {
        return (
          moment(record.lastStateChanged).format('L LTS')
        )
      }
    }, {
      title: 'Stav',
      dataIndex: 'occState',
      key: 'occState',
      width: 130,
      sorter: (a, b) => defaultSorter(a.occState, b.occState),
      render: (text, record) => {
        if (record.occState === 1) {
          return (
            <Badge
              status="error"
              text={"OBSAZENO"}
              title="Obsazeno" />
          );
        } else if (record.occState === 0) {
          return (
            <Badge
              status="success"
              text={"VOLNO"}
              title="Volno" />
          );
        } else {
          return (
            <Badge
              color="#6d6d6d"
              text={"Kalibrace / neznámý stav / chyba"}
              title="Kalibrace / neznámý stav / chyba" />
          )
        }
      }
    }, {
      title: 'Nastavený limit (min)',
      dataIndex: 'timeLimit',
      key: 'timeLimit',
      width: 130,
      sorter: (a, b) => defaultSorter(a.timeLimit, b.timeLimit),
    }, {
      title: 'Aktivní',
      dataIndex: 'isActive',
      key: 'isActive',
      width: 100,
      filters: [{
        text: 'ZAPNUTO',
        value: true,
      }, {
        text: 'VYPNUTO',
        value: false,
      }],
      filteredValue: filteredInfo.isActive || null,
      onFilter: (value, record) => { return ((record.isActive === value)) ? true : false },
      render: (text, record) => {
        if (record.isActive === true) {
          return (
            <Badge
              status="success"
              text="ANO" />
          );
        } else {
          return (
            <Badge
              status="error"
              text="NE"
              title="Vpořádku" />
          );
        }
      }
    }, {
      title: 'Zobrazený text',
      dataIndex: 'displayedString',
      key: 'displayedString',
      width: 120,
      render: (text, record) => {
        if (record.displayedString == '--') {
          return (
            <Tooltip title="Zhasnutá cedule"><Tag color='black'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</Tag></Tooltip>
          )
        } else {
          if (record.displayedString >= 0) {
            return (
              <Tooltip title="Povolené parkování"><Tag color="green">{record.displayedString}</Tag></Tooltip>
            )
          } else {
            return (
              <Tooltip title="Parkování přes limit"><Tag color="red">{Math.abs(parseInt(record.displayedString))}</Tag></Tooltip>
            )
          }
        }
      }
    }, {
      title: 'Akce',
      key: 'Action',
      width: 300,
      render: (text, record) => {
        const canWrite = UserModel.isInRoles(['ADMIN', 'TIMEOUTSIGNS_WRITE']);
        const canReset = UserModel.isInRoles(['ADMIN', 'TIMEOUTSIGNS_RESET']);
        if (!canWrite && !canReset) return null;
        return (
          <div>
            {canWrite && (
              <React.Fragment>
                <Divider type="vertical" />
                <a onClick={(e) => {
                  this.setState({
                    timeoutSignsSettingsFormData: record
                  });
                }}>Nastavení</a>
              </React.Fragment>
            )}
            {canReset && (
              <React.Fragment>
                <Divider type="vertical" />
                <Popconfirm
                  placement="right"
                  title="Opravdu si přejete tento časovač resetovat?"
                  okText="Ano"
                  cancelText="Ne"
                  onConfirm={() => {
                    TimeoutSignsModel.reset(record.id)
                      .then(() => {
                        message.success('Časovač byl resetován!');
                        this.props.onRowRemoved();
                      })
                      .catch(() => {
                        message.error('Časovač se nepodařilo resetovat!');
                      });
                  }}>
                  <a onClick={(e) => { e.preventDefault(); }}><Typography.Text type="warning">Resetovat</Typography.Text></a>
                </Popconfirm>
              </React.Fragment>
            )}
            {canWrite && (
              <React.Fragment>
                <Divider type="vertical" />
                <Popconfirm
                  placement="right"
                  title="Opravdu si přejete tento časovač smazat?"
                  okText="Ano"
                  cancelText="Ne"
                  onConfirm={() => {
                    TimeoutSignsModel.remove(record.id)
                      .then(() => {
                        message.success('Časovač byl odstraněn!');
                        this.props.onRowRemoved();
                      })
                      .catch(() => {
                        message.error('Časovač se nepodařilo smazat!');
                      });
                  }}>
                  <a onClick={(e) => { e.preventDefault(); }}><Typography.Text type="danger">Smazat</Typography.Text></a>
                </Popconfirm>
              </React.Fragment>
            )}
          </div>
        );
      }
    }]

    return (
      <div>
        <Table
          size='small'
          rowKey={this.props.rowKey ? this.props.rowKey : 'id'}
          loading={this.props.loading ? this.props.loading : false}
          columns={columns}
          dataSource={this.props.data}
          style={{ border: '0px' }}
          pagination={{
            showSizeChanger: true,
            defaultPageSize: localStorage.getItem('table_pageSize') !== undefined
              ? parseInt(localStorage.getItem('table_pageSize'))
              : 10,
            onShowSizeChange: (current, size) => {
              localStorage.setItem('table_pageSize', size);
            }
          }}
          onChange={this.handleChange}
          expandedRowRender={this.expandedRowRender.bind(this)}
          rowSelection={
            this.props.rowSelection !== undefined
              ? this.props.rowSelection
              : null
          }
        />

        <TimeoutSignsSettingsForm
          type="modal"
          modalVisible={this.state.timeoutSignsSettingsFormData === null ? false : true}
          initialValues={this.state.timeoutSignsSettingsFormData}
          onModalCancel={(form) => {
            form.resetFields();
            this.setState({ timeoutSignsSettingsFormData: null });
          }}
          onSuccess={(form, values) => {
            TimeoutSignsModel.update(this.state.timeoutSignsSettingsFormData.id, values)
              .then(() => {
                message.success("Změna byla uložena!");
                form.resetFields();
                this.setState({
                  timeoutSignsSettingsFormData: null
                });
                if (this.props.onAnyFormSuccess) {
                  this.props.onAnyFormSuccess();
                }
              })
              .catch(err => {
                message.warning('Změnu se nepodařilo uložit. Zkontrolujte spravnou funkčnost služby.');
              })
          }} />
      </div>
    );
  }
}

export default TimeoutSignsTable;


// WEBPACK FOOTER //
// ./src/components/TimeoutSignsTable.js